// extracted by mini-css-extract-plugin
module.exports = {"LandingPage":"LandingPage_LandingPage__3bopr","VehicleTypes":"LandingPage_VehicleTypes__1DRFA","type":"LandingPage_type__3Ytrx"};